import React, { useContext, useRef, useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Table,
  Card,
  InputGroup,
} from "react-bootstrap";
import { BiUpload } from "react-icons/bi";
import { FaRegEnvelope, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../utils/Helper";
const Addmamber = () => {
  const { id } = useParams();
  const location = useLocation();
  const { row } = location.state || {};
  const [image, setImage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { accessToken, logout, data } = useContext(UserContext);
  let currentUser = data;
  const [formData, setFormData] = useState({
    firstName: row?.first_name || "",
    lastName: row?.last_name || "",
    email: row?.email || "",
    mobile: row?.mobile || "",
    country_code: row?.country_code || "",
    country_id: row?.country_id || "",
    region_id: row?.region_id || "",
    state_id: row?.state_id || "",
    city_id: row?.city_id || "",
    user_type: row?.role_id || "",
    pin_code: row?.pin_code || "",
    password: row?.password || "",
    description: row?.description || "",
    profile_pic: row?.profile_pic || "",
  });
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [imagePreview, setImagePreview] = useState(row?.profile_pic || null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const FileInputRef = useRef(null);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const headers = {
    "content-type": "multipart/form-data",
    "auth-token": authToken,
    authorization: accessToken,
  };
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchCountries();
    fetchRegions(101);
    if (id) {
      if (id) {
        if (row?.region_id) fetchStates(row?.region_id);
        if (row?.region_id) fetchCities(row?.state_id);
      }
    }
  }, [id, row,currentUser]);

  
  useEffect(() => {
    if (currentUser) {
      fetchRole();
    }
  }, [currentUser]);

  const fetchRole = async () => {
    try {
      const response = await APIServices.get(
        `/admin/auth/role_list?status=Active&limit=100&system_role=1`,
        headers
      );
      if (response?.status === 200) {
        const roles = await response?.data?.list || [];
        let filteredUsers= [];
        console.log("currentUser",currentUser)
        if (currentUser?.user_type == "superadmin") {
          // Superadmin sees all users
          filteredUsers = roles;
      } else if (currentUser?.user_type == "Regional Manager") {
          // Remove 'Regional Manager' from the list
          filteredUsers = roles.filter(role => role.name !== "Regional Manager");
      } else if (currentUser?.user_type == "State Manager") {
          // Remove 'Regional Manager' and 'State Manager' from the list
          filteredUsers = roles.filter(role => role.name !== "Regional Manager" && role.name !== "State Manager");
      } else if (currentUser?.user_type == "City Manager") {
          // Remove 'Regional Manager', 'State Manager', and 'City Manager' from the list
          filteredUsers = roles.filter(role => role.name !== "Regional Manager" && role.name !== "State Manager" && role.name !== "City Manager");
      }
      console.log("filteredUsers",filteredUsers)
      setCategories(filteredUsers);
      } else {
        setCategories([]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await APIServices.get(
        "/admin/cms/country_list",
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setCountries(countriesList);
        const india = countriesList.find(
          (country) => country.name.toLowerCase() === "india"
        );
        if (india) {
          setFormData((pre) => {
            if (!pre.country_code && india) {
              return { ...pre, country_code: india.phonecode };
            }
            if (!pre.country_id && india) {
              return { ...pre, country_id: india.id };
            }
            return pre;
          });
        }
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setCountries([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountries([]);
    }
  };

  const fetchRegions = async (country_id) => {
    try {
      const response = await APIServices.get(
        `admin/cms/region_list/${country_id}`,
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setRegions(countriesList);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setRegions([]);
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([]);
    }
  };
  const fetchStates = async (regionId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/state_list/${regionId}`,
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setStates(countriesList);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };
  

  const fetchCities = async (stateId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/city_list/${stateId}`,
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setCities(countriesList);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profile_pic" && files.length > 0) {
      const file = files[0];
      setFormData((pre) => ({ ...pre, profile_pic: file }));
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else if (name === "mobile") {
      setFormData((pre) => ({ ...pre, [name]: value.replace(/[^0-9]/g, "") }));
    } else {
      setFormData((pre) => ({ ...pre, [name]: value }));
    }
    if (name === "region_id") {
      setFormData((pre) => ({ ...pre, state_id: "", city_id: "" }));
      fetchStates(value);
    }
    if (name === "state_id") {
      setFormData((pre) => ({ ...pre, city_id: "" }));
      fetchCities(value);
    }
    setErrors({ ...errors, [name]: "" });
  };
  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevState) => ({
        ...prevState,
        profile_pic: file,
      }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
      setFormData((prevState) => ({
        ...prevState,
        profile_pic: null,
      }));
    }
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First Name is required.";
    if (!formData.lastName) newErrors.lastName = "Last Name is required.";

    if (!formData.email) {
      newErrors.email = "Email address is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email address is invalid.";
    }
    if (!formData.mobile) {
      newErrors.mobile = "Phone number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Phone number is invalid.";
    }
    if (!formData.pin_code) {
      newErrors.pin_code = "Pincode is required.";
    } else if (!/^\d{6}$/.test(formData.pin_code)) {
      newErrors.pin_code = "Pincode is invalid (must be 6 digits).";
    }
    if (!id) {
      if (!formData.password) {
        newErrors.password = "Password is required.";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters.";
      } else if (formData.password.length > 20) {
        newErrors.password = "Password must not exceed 20 characters.";
      }

      if (!formData.confirmPassword) {
        newErrors.confirmPassword = "Confirm password is required.";
      } else if (formData.confirmPassword !== formData.password) {
        newErrors.confirmPassword = "Passwords do not match.";
      }
    }
    if (formData.profile_pic && formData.profile_pic instanceof File) {
      if (
        !["image/jpeg", "image/png", "image/gif"].includes(
          formData.profile_pic.type
        )
      ) {
        // newErrors.profile_pic = "Profile picture must be a JPG, PNG, or GIF";
      }
    } else if (!formData.profile_pic && !imagePreview) {
      // newErrors.profile_pic = "Profile picture is required.";
    }
    if (!formData.user_type) newErrors.user_type = "Role is required.";
    if(formData.user_type == 1){
      if (!formData.region_id) newErrors.region_id = "Region is required.";
    }
    if(formData.user_type == 2){
      if (!formData.region_id) newErrors.region_id = "Region is required.";
      if (!formData.state_id) newErrors.state_id = "State is required.";
    }
    if(formData.user_type == 3 || formData.user_type == 4){
      if (!formData.region_id) newErrors.region_id = "Region is required.";
      if (!formData.state_id) newErrors.state_id = "State is required.";
      if (!formData.city_id) newErrors.city_id = "City is required.";
    }
    // if (!formData.description)
    //   newErrors.description = "Description is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    const { firstName, lastName, ...rest } = formData;
    const updatedFormData = {
      ...rest,
    //   fullname: `${firstName} ${lastName}`.trim(),
	  first_name:firstName,
	  last_name:lastName,
	  user_type: formData.user_type,
    };

    const formDataToSubmit = new FormData();
    Object.keys(updatedFormData).forEach((key) => {
      formDataToSubmit.append(key, updatedFormData[key]);
    });

    try {
      if (id) {
        const updateFormData = { ...updatedFormData };
        updateFormData.id = id;
        const res = await APIServices.post(
          `/admin/member/update`,
          updateFormData,
          { "content-type": "multipart/form-data", ...headers }
        );
        if (res?.data?.status === true) {
          console.log("🚀 ~ handleSubmit ~ res:", res)
          showToast(res?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/members");
          }, 2000);
        } else if (res?.status === 401) {
          logout();
          navigate("/");
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      } else {
        const response = await APIServices.post(
          `/admin/member/add`,
          formDataToSubmit,
          headers
        );
        if (response?.data?.status === true) {
          showToast(response?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/members");
          }, 2000);
        } else if (response?.status === 401) {
          logout();
          navigate("/");
        } else {
          showToast(
            response?.data?.message || "Something went wrong.",
            "error"
          );
        }
      }
    } catch (error) {
      showToast("Something went wrong.", "error");
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      <div className="add_channel_sec add_member_sec">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">Add Member</h1>
        </div>

        <Card className="add_channel_form">
          <Card.Body>
            <Form className="">
              <Row>
                <Col md={12} lg={12}>
                  <div className="d-flex flex-column ">
                    <label htmlFor="upload-input" className="upload-circle">
                      {imagePreview ? (
                        <img
                          src={imagePreview}
                          alt="Uploaded"
                          className="uploaded-img"
                        />
                      ) : (
                        <BiUpload size={30} color="#333" />
                      )}
                    </label>
                    <Form.Control
                      type="file"
                      name="profile_pic"
                      id="upload-input"
                      className="d-none"
                      accept="image/jpeg,image/png,image/gif"
                      onChange={(e) => {
                        onImageChange(e);
                        handleChange(e);
                      }}
                      ref={FileInputRef}
                      isInvalid={!!errors.profile_pic}
                    />
                    <p className="mt-2 font_blue_14">Upload Profile Pic</p>
                  </div>
                  {errors.profile_pic && (
                    <div className="text-danger">{errors.profile_pic}</div>
                  )}
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group controlId="firstName">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      First Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      placeholder="Enter First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                    {errors.firstName && (
                      <div className="text-danger">{errors.firstName}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  <Form.Group controlId="lastName">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Last Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      placeholder="Enter Last Name"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                    {errors.lastName && (
                      <div className="text-danger">{errors.lastName}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  <Form.Group controlId="emailId">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Email ID
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter Email ID"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6} lg={4}>
                  <Form.Group controlId="phoneNo">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Phone No
                    </Form.Label>
                    <InputGroup>
                      <Form.Select
                        name="country_code"
                        value={formData.country_code || "+91"} 
                        onChange={handleChange}
                        style={{ maxWidth: "140px", borderWidth: "0px" }}
                        disabled

                      >
                        {countries.map((country, index) => (
                          <option key={country.id} value={country.phonecode}>
                            {country.name} ({country.phonecode})
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control
                        type="text"
                        name="mobile"
                        placeholder="Enter Phone No"
                        maxLength="10"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    {errors.mobile && (
                      <div className="text-danger">{errors.mobile}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  <Form.Group controlId="user_type">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Role
                    </Form.Label>
                    <Form.Select
                      name="user_type"
                      value={formData.user_type}
                      onChange={handleChange}
                      disabled={id}
                    >
                      <option value="">Select Role</option>
                      {categories.map((category) => (
                        <option key={category.id}  value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.user_type && (
                      <div className="text-danger">{errors.user_type}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  <Form.Group controlId="region_id">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Region
                    </Form.Label>
                    <Form.Select
                      name="region_id"
                      value={formData.region_id}
                      onChange={handleChange}
                      disabled={id}

                    >
                      <option value="">Select Region</option>
                      {regions.map((region) => (
                        <option key={region.id} value={region.id}>
                          {capitalizeFirstLetter(region.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.region_id && (
                      <div className="text-danger">{errors.region_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  <Form.Group controlId="state_id">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      State
                    </Form.Label>
                    <Form.Select
                      name="state_id"
                      value={formData.state_id}
                      onChange={handleChange}
                      disabled={id}

                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.id} value={state.id}>
                          {capitalizeFirstLetter(state.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.state_id && (
                      <div className="text-danger">{errors.state_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  <Form.Group controlId="city_id">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      City
                    </Form.Label>
                    <Form.Select
                      name="city_id"
                      value={formData.city_id}
                      onChange={handleChange}
                      disabled={id}

                    >
                      <option value="">Select city</option>
                      {cities.map((city) => (
                        <option key={city.id} value={city.id}>
                          {capitalizeFirstLetter(city.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.city_id && (
                      <div className="text-danger">{errors.city_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  <Form.Group controlId="pincode">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Pincode
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="pin_code"
                      placeholder="Enter pincode"
                      value={formData.pin_code}
                      onChange={handleChange}
                    />
                    {errors.pin_code && (
                      <div className="text-danger">{errors.pin_code}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                  {!id ? (
                    <Form.Group className="mb-2" controlId="formPassword">
                      <Form.Label className="font_blue_14 font-500 mb-2">
                        Password
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="Enter Password"
                          value={formData.password}
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                        />
                        <InputGroup.Text
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                        </InputGroup.Text>
                      </InputGroup>
                      {errors.password && (
                        <div className="text-danger">{errors.password}</div>
                      )}
                    </Form.Group>
                  ) : (
                    ""
                  )}
                </Col>
                <Col md={6} lg={4}>
                  {!id ? (
                    <Form.Group className="mb-2" controlId="formConfirmPassword">
                      <Form.Label className="font_blue_14 font-500 mb-2">
                        Confirm Password
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmPassword"
                          placeholder="Enter Confirm Password"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          isInvalid={!!errors.confirmPassword}
                        />
                        <InputGroup.Text
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <FaRegEye />
                          ) : (
                            <FaRegEyeSlash />
                          )}
                        </InputGroup.Text>
                      </InputGroup>
                      {errors.confirmPassword && (
                        <div className="text-danger">
                          {errors.confirmPassword}
                        </div>
                      )}
                    </Form.Group>
                  ) : (
                    ""
                  )}
                </Col>
				       <Col md={12} lg={12}>
								  <Form.Group className="mb-3">
									<Form.Label className="font_blue_14 font-500 mb-2 ">
									  Description
									</Form.Label>
									<Form.Control
									  as="textarea"
									  rows={3}
									  name="description"
									  placeholder="Write here..."
									  value={formData.description}
									  onChange={handleChange}
                    style={{ height: "120px" }}
									/>
									{errors.description && (
									  <div className="text-danger">{errors.description}</div>
									)}
								  </Form.Group>
								</Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  className="btn blue_border"
                  onClick={() => navigate("/admin/members")}
                >
                  Cancel
                </Button>
                <Button className="btn red_button" onClick={handleSubmit}>
                  {id ? "Update" : "Add"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
        <ToastContainer />
    </>
  );
};

export default Addmamber;
